import { render, staticRenderFns } from "./MdtSidepanel.vue?vue&type=template&id=0ac28a32&scoped=true"
import script from "./MdtSidepanel.vue?vue&type=script&lang=js"
export * from "./MdtSidepanel.vue?vue&type=script&lang=js"
import style0 from "./MdtSidepanel.vue?vue&type=style&index=0&id=0ac28a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac28a32",
  null
  
)

export default component.exports